<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Edit Barang</h5>
            <hr />
            <h3 class="mb-0">{{ data.type }} <span v-if="data.year != null">(Tahun {{ data.year }})</span></h3>
            {{ data.kind }} - {{ data.brand }}
            <div class="mt-2">
                <!-- Harga Dasar: <strong>Rp. {{ $helper.formatThousand(data.base_price) }}</strong><br /> -->
            </div>
            <hr />
            <b-row>
                <b-col md="4">
                    <div class="font-weight-bold mb-3">Adjustment Harga</div>
                    <b-form-group label="Adjustment Batangan" description="Bila kosong, maka menggunakan rumus umum">
                        <b-input-group prepend="Rp.">
                            <b-input v-model="input.adjBatangan" @input="sanitize('adjBatangan')" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Adjustment Grade S"
                        description="Bila kosong, maka barang ini tidak memiliki Grade S">
                        <b-input-group prepend="Rp.">
                            <b-input v-model="input.adjS" @input="sanitize('adjS')" />
                        </b-input-group>
                    </b-form-group>
                    <!-- <b-form-group label="Adjustment Grade B" description="Bila kosong, maka adjustment mengikuti rumus umum">
                        <b-input-group prepend="Rp.">
                            <b-input v-model="input.adjB" @input="sanitize('adjB')" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Adjustment Grade C" description="Bila kosong, maka adjustment mengikuti rumus umum">
                        <b-input-group prepend="Rp.">
                            <b-input v-model="input.adjC" @input="sanitize('adjC')" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Adjustment Grade X" description="Bila kosong, maka adjustment mengikuti rumus umum">
                        <b-input-group prepend="Rp.">
                            <b-input v-model="input.adjD" @input="sanitize('adjD')" />
                        </b-input-group>
                    </b-form-group> -->
                </b-col>
                <b-col md="4">
                    <div class="font-weight-bold mb-3">Harga</div>
                    <b-form-group v-for="(spec, index) in orderSpecById" v-bind:key="spec.id" :label="'Harga ' + spec.name"
                        >
                        <b-input-group prepend="Rp.">
                            <b-input disabled v-model="spec.adj" @input="sanitizeSpec(index)" />
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Harga Barang Baru"
                       >
                        <b-input-group prepend="Rp.">
                            <b-input disabled v-model="input.priceNew" @input="sanitize('priceNew')" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <div class="font-weight-bold mb-3">Dimensi & Berat</div>
                    <b-form-group label="Panjang" description="Bila kosong, maka Dimensi Panjang barang ini akan dihapus">
                        <b-input-group append="cm">
                            <b-input @keypress="numberOnly" v-model="input.length" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Lebar" description="Bila kosong, maka Dimensi Lebar barang ini akan dihapus">
                        <b-input-group append="cm">
                            <b-input @keypress="numberOnly" v-model="input.width" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Tinggi" description="Bila kosong, maka Dimensi Tinggi barang ini akan dihapus">
                        <b-input-group append="cm">
                            <b-input @keypress="numberOnly" v-model="input.height" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Berat" description="Bila kosong, maka Berat barang ini akan dihapus">
                        <b-input-group append="gr">
                            <b-input @keypress="numberOnly" v-model="input.weight" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="success" :disabled="isSubmitting" @click="confirmSave">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,

            segment: "",
            id: 0,

            data: {},

            input: {
                adjBatangan: "",
                adjS: "",
                adjB: "",
                adjC: "",
                adjD: "",
                specs: [],
                length: "",
                width: "",
                height: "",
                weight: "",
                priceNew : ""
            }

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.$axios.get(`master/item/${this.segment}/${this.id}?forEdit=true`).then(res => {

                this.initStatus = 1
                this.data = res.data.data

                this.input.adjBatangan = this.$helper.formatThousand(this.data.adj_batangan, "")
                this.input.adjS = this.$helper.formatThousand(this.data.adj_s, "")
                this.input.adjB = this.$helper.formatThousand(this.data.adj_b, "")
                this.input.adjC = this.$helper.formatThousand(this.data.adj_c, "")
                this.input.adjD = this.$helper.formatThousand(this.data.adj_d, "")
                this.input.length = this.data.length
                this.input.width = this.data.width
                this.input.height = this.data.height
                this.input.weight = this.data.weight

                this.input.specs = this.data.specs
                this.input.priceNew = this.$helper.formatThousand(this.data.price_new)
                this.input.specs.forEach(it => {
                    it.adj = this.$helper.formatThousand(it.adj, "")
                })

            })
                .catch(error => this.initStatus = -1)

        },

        confirmSave() {

            let isConfirmed = confirm("Simpan data berikut ini?")
            if (!isConfirmed) return

            this.isSubmitting = true

            let numberedSpecs = []
            this.input.specs.forEach(it => {

                if (it.adj != null && it.adj != "") {
                    numberedSpecs.push({
                        id: it.id,
                        adj: this.$helper.toNumber(it.adj, null)
                    })
                }

            })

            let payload = {
                id: this.id,
                part: this.segment,
                adjBatangan: this.input.adjBatangan != "" ? this.$helper.toNumber(this.input.adjBatangan, null, true) : null,
                adjS: this.$helper.toNumber(this.input.adjS, null, true),
                adjB: this.$helper.toNumber(this.input.adjB, null, true),
                adjC: this.$helper.toNumber(this.input.adjC, null, true),
                adjD: this.$helper.toNumber(this.input.adjD, null, true),
                length: this.input.length,
                width: this.input.width,
                height: this.input.height,
                weight: this.input.weight,
                specs: numberedSpecs
            }

            this.$axios.post("master/item/update", payload).then(res => {
                this.$helper.toastSuccess(this, "Data baru berhasil disimpan!")
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        sanitize(varName) {

            console.log('test',varName)
            let cleaned = String(this.input[varName]).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")


            this.input[varName] = res

        },

        sanitizeSpec(index) {

            let cleaned = String(this.input.specs[index].adj).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.specs[index].adj = res

        },

        numberOnly(event) {
            if (event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13) {
                return true
            } else {
                event.preventDefault()
            }
        },

    },
    created() {
        this.segment = this.$route.params.segment
        this.id = this.$route.params.id
        this.init()
    },
    computed:{
        orderSpecById () {
            if (this.input.specs.length > 0) {
                const sortedSpecs = [...this.input.specs].sort((a, b) => a.id - b.id);
                return sortedSpecs;
            } else {
                return []
            }
        }
    }
}
</script>
